function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "in-house");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "User-Interface",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Icons",
  transform: "translate(-220.000000, -1168.000000)"
}, React.createElement("g", {
  id: "in-house",
  transform: "translate(219.000000, 1169.000000)"
}, React.createElement("g", null, React.createElement("g", {
  id: "bg",
  fill: "#FFFFFF",
  stroke: "#DADADA",
  strokeWidth: 1.5
}, React.createElement("polygon", {
  id: "Polygon",
  points: "42 3 78.373067 24 78.373067 66 42 87 5.62693304 66 5.62693304 24"
}), React.createElement("path", {
  d: "M42,84 C43.6568542,84 45,85.3431458 45,87 C45,88.6568542 43.6568542,90 42,90 C40.3431458,90 39,88.6568542 39,87 C39,85.3431458 40.3431458,84 42,84 Z M80.3442101,63.5 C81.779088,64.3284271 82.2707135,66.1631983 81.4422863,67.5980762 C80.6138592,69.0329541 78.779088,69.5245795 77.3442101,68.6961524 C75.9093323,67.8677253 75.4177068,66.0329541 76.2461339,64.5980762 C77.074561,63.1631983 78.9093323,62.6715729 80.3442101,63.5 Z M8.22500925,64.5 C9.05343638,65.9348779 8.56181091,67.7696491 7.12693304,68.5980762 C5.69205517,69.4265033 3.85728395,68.9348779 3.02885683,67.5 C2.2004297,66.0651221 2.69205517,64.2303509 4.12693304,63.4019238 C5.56181091,62.5734967 7.39658213,63.0651221 8.22500925,64.5 Z M7.59807621,21.5 C9.03295408,22.3284271 9.52457955,24.1631983 8.69615242,25.5980762 C7.8677253,27.0329541 6.03295408,27.5245795 4.59807621,26.6961524 C3.16319834,25.8677253 2.67157288,24.0329541 3.5,22.5980762 C4.32842712,21.1631983 6.16319834,20.6715729 7.59807621,21.5 Z M80.9711432,22.5 C81.7995703,23.9348779 81.3079448,25.7696491 79.873067,26.5980762 C78.4381891,27.4265033 76.6034179,26.9348779 75.7749907,25.5 C74.9465636,24.0651221 75.4381891,22.2303509 76.873067,21.4019238 C78.3079448,20.5734967 80.142716,21.0651221 80.9711432,22.5 Z M42,0 C43.6568542,0 45,1.34314575 45,3 C45,4.65685425 43.6568542,6 42,6 C40.3431458,6 39,4.65685425 39,3 C39,1.34314575 40.3431458,0 42,0 Z",
  id: "Combined-Shape"
})), React.createElement("g", {
  id: "Group-4",
  transform: "translate(20.000000, 22.000000)"
}, React.createElement("g", {
  id: "Group-3",
  stroke: "#27294F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, React.createElement("g", {
  id: "smart-house",
  transform: "translate(0.000000, -0.000000)"
}, React.createElement("polyline", {
  id: "Path",
  points: "0 17.6 22 0 44 17.6"
}), React.createElement("polyline", {
  id: "Path",
  points: "5.86666667 19.0666667 5.86666667 41.0666667 38.1333333 41.0666667 38.1333333 19.0666667"
}))), React.createElement("g", {
  id: "server-rack",
  transform: "translate(11.000000, 18.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  stroke: "#27294F",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x: 0,
  y: 0,
  width: 21.7582418,
  height: 7.25274725
}), React.createElement("line", {
  x1: 7.25274725,
  y1: 3.62637363,
  x2: 3.62637363,
  y2: 3.62637363,
  id: "Path",
  stroke: "#0276F1",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("circle", {
  id: "Oval",
  fill: "#0276F1",
  fillRule: "nonzero",
  cx: 18.1318681,
  cy: 3.62637363,
  r: 1
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#27294F",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x: 0,
  y: 11.6043956,
  width: 21.7582418,
  height: 7.25274725
}), React.createElement("line", {
  x1: 7.25274725,
  y1: 15.2307692,
  x2: 3.62637363,
  y2: 15.2307692,
  id: "Path",
  stroke: "#0276F1",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("circle", {
  id: "Oval",
  fill: "#0276F1",
  fillRule: "nonzero",
  cx: 18.1318681,
  cy: 15.2307692,
  r: 1
}), React.createElement("line", {
  x1: 2.9010989,
  y1: 7.25274725,
  x2: 2.9010989,
  y2: 9.42857143,
  id: "Path",
  stroke: "#27294F",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 18.8571429,
  y1: 7.25274725,
  x2: 18.8571429,
  y2: 9.42857143,
  id: "Path",
  stroke: "#27294F",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))));

var SvgInHouse = function SvgInHouse(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "82px",
    height: "92px",
    viewBox: "0 0 82 92",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInHouse, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };